import { COLORS } from '@/utils/static/colors';

export const DISPLAY_DOC_SUBTYPE = {
  TAX_DECLARATION: 'Tax declaration',
  BANK_ACCOUNT_STATEMENT: 'Bank account statement with sufficient amount',
  TAX_PAID_STATEMENT: 'Tax paid statement',
  OTHER: 'Other'
};

export const SHOWED_SECTIONS_COUNT = 1;

export const STATUS = {
  NEW: 'PENDING',
  PASSED: 'ACCEPTED',
  DRAFT: 'DRAFT',
  REJECTED: 'UNACCEPTED',
  NEED_CHECKING: 'PRE_PROCESSING',
  QUESTION_UNACCEPTED: 'QUESTION_UNACCEPTED',
  PROCESSING: 'PROCESSING'
};

export const STATUSES_IN_PROGRESS = {
  PROCESSING: true,
  UNACCEPTED: true
};

export const STATUSES_WITH_ANSWERS = {
  DRAFT: true,
  PROCESSING: true,
  UNACCEPTED: true,
  QUESTION_UNACCEPTED: true,
  PRE_PROCESSING: true,
  ACCEPTED: true,
  PENDING: true
};
export const STATUSES_WITH_DISABLED = {
  PROCESSING: true,
  QUESTION_UNACCEPTED: true,
  ACCEPTED: true
};
export const STATUSES_WITH_CLEAR = {
  QUESTION_UNACCEPTED: true,
  UNACCEPTED: true
};

export const STATUS_DISPLAY = {
  PENDING: 'NEW',
  DRAFT: 'DRAFT',
  PROCESSING: 'IN REVIEW',
  QUESTION_UNACCEPTED: 'QUESTIONS REJECTED',
  UNACCEPTED: 'REJECTED',
  PRE_PROCESSING: 'NEEDS CHECKING',
  ACCEPTED: 'PASSED',
  REQUEST_DOCUMENT: 'REQUEST DOCUMENT'
};

export const STATUS_VERIFICATION_DISPLAY = {
  New: 'New',
  'In process': 'In process',
  Rejected: 'Rejected',
  Approved: 'Approved',
  UPLOAD_DOCUMENT: 'UPLOAD DOCUMENT',
  ACCEPTED_DOCUMENT: 'ACCEPTED DOCUMENT',
  REJECTED_DOCUMENT: 'REJECTED DOCUMENT',
  REQUEST_PRODUCT: 'REQUEST PRODUCT',
  UPDATED_PRODUCT_STATUS: 'UPDATED PRODUCT STATUS',
  LINK_AGENT: 'LINK AGENT',
  LINK_RECOMMENDER: 'LINK RECOMMENDER',
  REQUEST_REF_CODE: 'REQUEST CODE'
};

export const NOTIFICATIONS_STATUS_DISPLAY = {
  REQUEST_DOCUMENT: 'REQUEST DOCUMENT',
  AWAITING_VERIFICATION: 'AWAITING VERIFICATION',
  ACCEPTED_QUESTIONNAIRE: 'ACCEPTED QUESTIONNAIRE',
  CREATED_INVESTOR: 'CREATED INVESTOR',
  CREATED_COMPANY: 'CREATED COMPANY',
  CREATED_AGENT: 'CREATED AGENT',
  CREATED_RECOMMENDER: 'CREATED RECOMMENDER',
  REJECTED_QUESTIONNAIRE: 'REJECTED QUESTIONNAIRE',
  UPLOAD_DOCUMENT: 'UPLOAD DOCUMENT',
  ACCEPTED_DOCUMENT: 'ACCEPTED DOCUMENT',
  REJECTED_DOCUMENT: 'REJECTED DOCUMENT',
  REQUEST_PRODUCT: 'REQUEST PRODUCT',
  UPDATED_PRODUCT_STATUS: 'UPDATED PRODUCT STATUS',
  LINK_AGENT: 'LINK AGENT',
  LINK_RECOMMENDER: 'LINK RECOMMENDER',
  REJECTED_QUESTION: 'REJECTED QUESTION'
};

export const NON_ADMIN_NOTIFICATIONS_TYPE = {
  ACCEPTED_QUESTIONNAIRE: true,
  REJECTED_QUESTIONNAIRE: true,
  ACCEPTED_DOCUMENT: true,
  REJECTED_DOCUMENT: true,
  UPDATED_PRODUCT_STATUS: true,
  REJECTED_QUESTION: true
};

export const STATUS_COLOR = {
  PENDING: COLORS.newStatus,
  DRAFT: COLORS.draftStatus,
  PROCESSING: COLORS.inProcessStatus,
  QUESTION_UNACCEPTED: COLORS.red,
  UNACCEPTED: COLORS.red,
  PRE_PROCESSING: COLORS.yellow,
  ACCEPTED: COLORS.mintGreen,
  New: COLORS.newStatus,
  'In process': COLORS.inProcessStatus,
  Rejected: COLORS.red,
  Approved: COLORS.mintGreen,
  UPLOAD_DOCUMENT: COLORS.lightBlue,
  ACCEPTED_DOCUMENT: COLORS.mintGreen,
  REJECTED_DOCUMENT: COLORS.red,
  REQUEST_PRODUCT: COLORS.lightBlue,
  UPDATED_PRODUCT_STATUS: COLORS.orange,
  LINK_AGENT: COLORS.lightBlue,
  LINK_RECOMMENDER: COLORS.lightBlue,
  REQUEST_DOCUMENT: COLORS.lightBlue,
  AWAITING_VERIFICATION: COLORS.orange,
  REJECTED_QUESTIONNAIRE: COLORS.red,
  ACCEPTED_QUESTIONNAIRE: COLORS.mintGreen,
  CREATED_INVESTOR: COLORS.lightBlue,
  CREATED_COMPANY: COLORS.lightBlue,
  CREATED_AGENT: COLORS.lightBlue,
  CREATED_RECOMMENDER: COLORS.lightBlue,
  REJECTED_QUESTION: COLORS.red,
  REQUEST_REF_CODE: COLORS.aragonDarkBlue
};

export const ENABLED_STATUSES_INVESTOR = {
  PENDING: true,
  DRAFT: true,
  QUESTION_UNACCEPTED: true,
  UNACCEPTED: true
};
export const ENABLED_DOC_STATUSES_ADMIN = {
  PROCESSING: true
};
export const ENABLED_DOC_TO_VIEW_STATUSES_ADMIN = {
  PENDING: true,
  DRAFT: true,
  PROCESSING: true,
  QUESTION_UNACCEPTED: true,
  UNACCEPTED: true,
  ACCEPTED: true
};
export const ENABLED_QUESTS_TO_INTERACT_STATUSES_ADMIN = {
  PROCESSING: true,
  QUESTION_UNACCEPTED: true,
  PRE_PROCESSING: true,
  UNACCEPTED: true
};
export const ENABLED_QUESTS_TO_VIEW_STATUSES_ADMIN = {
  PENDING: true,
  DRAFT: true,
  PROCESSING: true,
  QUESTION_UNACCEPTED: true,
  UNACCEPTED: true,
  ACCEPTED: true
};
